import TextField from '@mui/material/TextField';
import { useEffect, useState, useRef } from 'react'; 
import Skeleton from '@mui/material/Skeleton';
import { createTheme, ThemeProvider, Typography,InputAdornment } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";

const theme = createTheme({
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400'
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&.MuiInputBase-input": {
              fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: '400'
            },
            '&::placeholder': {
              fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: '400'
            },
          },
        },
      },
    },
  });

const PageInputCopy = ({ tag, value, setValue, width, font, showError, disableEdit, isLoading ,topAlignTypography=false, showSearchIcon=false, showTitle=true}) =>{
    // initialize ref
    const ref = useRef();
    // set width if not given as prop
    if (width == null){
        width = '100%';
    }
    // set font size if given as prop, else use default
    let style = {};
    if (font){
        style['fontSize'] = font;
    } 
    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 
    
    return (
        <>
            { isLoading ? 
            <>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
            </>
            : /* material ui textfield for text input */
            <ThemeProvider theme={theme}>
            <div className={topAlignTypography ? 'd-flex flex-column align-items-start w-100': 'd-flex gap-2 align-items-center w-100'}>
                <Typography>
                    {showTitle ? tag: null}
                </Typography>
                <TextField 
                    sx={{ width: width, maxWidth: width }}
                    placeholder={'Search '+tag}
                    title={showTitle ? tag: null}
                    id="outlined-basic" 
                    size='small' 
                    variant="outlined" 
                    value={value} 
                    onChange={(e)=>setValue(value => value = e.target.value)}
                    inputProps={{style: style, readOnly: disableEdit}} // font size of input text
                    InputLabelProps={{style: style}} // font size of input label
                    error={error}
                    inputRef={ref} 
                    InputProps={{
                      startAdornment: (
                        showSearchIcon ? <InputAdornment position="start">
                          <SearchIcon
                            sx={{
                              width: "24px",
                              height: "24px",
                              color: "#54585A",
                            }}
                          />
                        </InputAdornment> : null
                      ),
                    }}
                />
            </div>
            </ThemeProvider>}
        </> 
    );
} 

export default PageInputCopy;